import { observeElement } from '@uvocore-front/utils';
/* eslint-disable  no-new */
import Carousel from '../../components/CustomCarousel';
import Accordion from '../../components/Accordion';

import '../../components/Header/main';
import '../../components/Footer';
import '../../components/Calculator/default';
import '../../components/Universities';
import '../../components/ImageListWithSlider';
import '../../sections/sample-section';
import '../../sections/testimonials-section';
import '../../sections/universities-map-section';

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.universities-section__list')) {
    observeElement({
      element: '.universities-section__list',
      marginValue: 200,
      callback: () => {
        new Carousel({
          selector: document.querySelector('.universities-section__list'),
          itemWidth: 200,
          margin: 44,
          activeSlide: 1,
          responsive: {
            768: {
              inactive: true,
            },
          },
        });
      },
    });
  }

  if (document.querySelector('.Accordion')) {
    observeElement({
      element: '.Accordion',
      marginValue: 400,
      callback: () => {
        new Accordion({
          itemsSelector: '.Accordion__item',
        });
      },
    });
  }
});
